export const withLinkPhone = (value, fieldKey) =>
    fieldKey === 'phone'
        ? <a href={`tel:+${value}`}>{value}</a>
        : value

export const capitalizeFirstLetter = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
}